import { render } from "./MonedaForm.vue?vue&type=template&id=490190b8&scoped=true"
import script from "./MonedaForm.vue?vue&type=script&lang=js"
export * from "./MonedaForm.vue?vue&type=script&lang=js"

import "./MonedaForm.vue?vue&type=style&index=0&id=490190b8&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-490190b8"]])

export default __exports__